import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";

import { getTranslations } from "@/api";

import { useCurrentLanguage } from "./useLanguage";

export function useCurrentTranslations() {
  const currentLanguage = useCurrentLanguage();

  const currentLanguageId = computed(() => currentLanguage.data.value?.id);
  const query = useQuery({
    queryKey: ["translations", currentLanguageId],
    queryFn: async () => getTranslations(currentLanguageId.value),
    enabled: computed(() => !!currentLanguageId.value),
  });

  const data = computed(() => query.data.value?.data?.results || []);
  const isFetching = computed(() => query.isFetching.value);

  return { data, isFetching };
}
